import { Breadcrumb, Modal } from "antd";
import { getResource } from "../../helpers/ResourcesHelper";
import Button from "../inputs/Button";

const ConfirmationModal = (props: any) => {

  return <Modal
    title={
      <div className="breadcrumb-container">
        <Breadcrumb separator="">
          <Breadcrumb.Item >{props.mainTitle ? props.mainTitle : 'Important'}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
    }
    centered
    visible={props.visible}
    footer={null}
    onCancel={props.cancel}
    maskClosable={false}

    zIndex={1021}
    closable={false}
  >
    <div>
      <div>
        <h4>{props.title}</h4>
      </div>
      <div className="row-actions-w">
        <Button id="confirmation-afex-OK" type="primary" onClick={props.confirm}>
          {getResource('Yes')}
        </Button>
        <Button id="confirmation-afex-cancel" type="primary" onClick={props.cancel}>
          {getResource('No')}
        </Button>
      </div>
    </div>
  </Modal>
}

export default ConfirmationModal